import { productCategories } from '@socialgoodsoftware/frbac';

const categoryVars: Record<string, string> = {
  audience: 'var(--color-category-audience)',
  money: 'var(--color-category-money)',
  frontOfHouse: 'var(--color-category-front-of-house)',
  platform: 'var(--color-category-platform)',
};

export function getCategoryColor(key: string | undefined): string {
  if (key === undefined) {
    return 'var(--color-border)';
  }
  return categoryVars[key] || 'var(--color-border)';
}

export function getCategoryLabel(key: string | undefined): string {
  const found = productCategories.find((category) => category.key === key);
  if (found) {
    return found.label;
  }
  return '';
}
